import { CSSProperties, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { iSFScheduleLine } from "../interfaceSFClient";

import { dateFormatter, dateShortFormatter } from "../util";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectPrintSchedule, setTitle } from "../app/appSlice";

import './Schedule.css';

function ScheduleRow({ data }: { data: iSFScheduleLine }) {

    const { Uhrzeit, Fallnummer, OALA, Geburtsdatum, Geschlecht, Name, Bemerkungen, OffenerBetrag } = data;

    const rowS = [Uhrzeit, Fallnummer, OALA, Geburtsdatum.length && dateShortFormatter.format(new Date(Geburtsdatum)), Geschlecht,
        null, null, null, Name.replaceAll(" ", "&nbsp;"), null, null, null, Bemerkungen, Fallnummer !== "" && (OffenerBetrag > 0 ? "nein" : "ja")];

    return (
        <tr>
            {rowS.map((td, i) => {
                let fontSize = "inherit";
                if (i === 12 && typeof td === "string" && td.length > 20) {
                    fontSize = Math.round(100 - td.length / 2.5) + "%"
                }
                const style: CSSProperties = {
                    fontSize
                }
                return (
                    <td key={i} style={style} dangerouslySetInnerHTML={{ __html: td || "" }}></td>
                );
            })}
        </tr>
    );
}

export default function Schedule() {

    const dispatch = useAppDispatch();

    const schedule = useAppSelector(selectPrintSchedule);

    useEffect(() => {
        if (schedule?.time) dispatch(setTitle(`Arbeitsplan ${schedule.bffName} ${schedule.time}`));
        setTimeout(window.print, 300);
    }, [dispatch, schedule]);

    if (!schedule) return (
        <Navigate to={"/"} />
    );

    const { time, bffName, med1, psy1, kunden } = schedule;

    const Med = med1 === "unbekannt" ? <span className="Blank" /> : <strong>{med1}</strong>;
    const Psy = psy1 === "unbekannt" ? <span className="Blank" /> : <strong>{psy1}</strong>;

    return (
        <div className="Schedule">
            <h1>Arbeitsplan für {bffName} vom {dateFormatter.format(new Date(time!))}</h1>
            <h2>Mediziner: {Med}, Psychologe: {Psy}</h2>
            <table>
                <thead>
                    <tr>
                        <th rowSpan={2}>Uhrzeit</th>
                        <th rowSpan={2}>Fallnummer</th>
                        <th rowSpan={2}>OA/LA</th>
                        <th rowSpan={2}>Geb.Datum</th>
                        <th rowSpan={2}>m/w</th>
                        <th colSpan={2}>Ergebnis</th>
                        <th rowSpan={2}>BAK</th>
                        <th rowSpan={2}>Name des KD</th>
                        <th colSpan={3}>Gutachter</th>
                        <th rowSpan={2}>Bemerkungen</th>
                        <th rowSpan={2}>alles bezahlt</th>
                    </tr>
                    <tr>
                        <th>M</th>
                        <th>P</th>
                        <th>M</th>
                        <th>P</th>
                        <th>Tests</th>
                    </tr>
                </thead>
                <tbody>
                    {kunden.map(line => <ScheduleRow key={line.Id} data={line} />)}
                </tbody>
            </table>
        </div>
    );
}